<template>
  <categories-detail :is-edit='true'>
  </categories-detail>
</template>

<script>
import CategoriesDetail from '../components/CategoriesDetail'
export default {
  name: 'EditCategories',
  components: {
    CategoriesDetail
  }
}
</script>

